import React from "react";
import legendStyles from "../../../css/table/LegendStyles.scss";
import { useTranslation } from "react-i18next";
import { renderMatchStatus } from "./matchStatusUtils";

const Legend = () => {
    const { t } = useTranslation();

    return (
        <div className={legendStyles.wrap}>
            <div className={legendStyles.block}>
                <div className={legendStyles.item}>
                    <div className={legendStyles.image}>
                        {renderMatchStatus("S")}
                    </div>
                    <div className={legendStyles.description}>
                        {t("dhb.teammgmt.squad.core")}
                    </div>
                </div>
                <div className={legendStyles.item}>
                    <div className={legendStyles.image}>
                        {renderMatchStatus("S1")}
                    </div>
                    <div className={legendStyles.description}>
                        {t("dhb.teammgmt.squad.core.bymatches")}
                    </div>
                </div>
                <div className={legendStyles.item}>
                    <div className={legendStyles.image}>
                        {renderMatchStatus("S2")}
                    </div>
                    <div className={legendStyles.description}>
                        {t("dhb.teammgmt.squad.core.remaining")}
                    </div>
                </div>
                <div className={legendStyles.item}>
                    <div className={legendStyles.image}>
                        {renderMatchStatus("G", {}, false)}
                    </div>
                    <div className={legendStyles.description}>
                        {t("dhb.config.cards.green")}
                    </div>
                </div>
                <div className={legendStyles.item}>
                    <div className={legendStyles.image}>
                        {renderMatchStatus("Y", {}, false)}
                    </div>
                    <div className={legendStyles.description}>
                        {t("dhb.config.cards.yellow")}
                    </div>
                </div>
                <div className={legendStyles.item}>
                    <div className={legendStyles.image}>
                        {renderMatchStatus("YR", {}, false)}
                    </div>
                    <div className={legendStyles.description}>
                        {t("dhb.config.cards.yellowred")}
                    </div>
                </div>
                <div className={legendStyles.item}>
                    <div className={legendStyles.image}>
                        {renderMatchStatus("R", {}, false)}
                    </div>
                    <div className={legendStyles.description}>
                        {t("dhb.config.cards.red")}
                    </div>
                </div>
            </div>
            <div className={legendStyles.block}>
                <div className={legendStyles.item}>
                    <div
                        className={legendStyles.image}
                        style={{ backgroundColor: "#ddd" }}
                    >
                        {renderMatchStatus("ETW")}
                    </div>
                    <div className={legendStyles.description}>
                        {t("dhb.leaguemgmt.team.substitute_gk.not_played")}
                    </div>
                </div>
                <div className={legendStyles.item}>
                    <div
                        className={legendStyles.image}
                        style={{ color: "red" }}
                    >
                        {renderMatchStatus("P")}
                    </div>
                    <div className={legendStyles.description}>
                        {t("dhb.passportmgmt.passport.invalid")}
                    </div>
                </div>
                <div className={legendStyles.item}>
                    <div
                        className={legendStyles.image}
                        style={{ backgroundColor: "#ffa7a7" }}
                    >
                        {renderMatchStatus("A")}
                    </div>
                    <div className={legendStyles.description}>
                        {t("dhb.player.suspended")}
                    </div>
                </div>
                <div className={legendStyles.item}>
                    <div
                        className={legendStyles.image}
                        style={{ backgroundColor: "#cce0e7" }}
                    >
                        {renderMatchStatus("Z")}
                    </div>
                    <div className={legendStyles.description}>
                        {t("dhb.teammgmt.squad.core.withdrawn")}
                    </div>
                </div>
                <div className={legendStyles.item}>
                    <div className={legendStyles.image}>
                        {renderMatchStatus("X")}
                    </div>
                    <div className={legendStyles.description}>
                        {t("dhb.player.played")}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Legend;
